import React, { memo, HTMLProps } from 'react';
import classnames from 'classnames';
import { SIZE, STATE } from '@zmedia/bm-soccer-ui/constants';
import Element from '../../element';
import styles from './button.module.scss';

interface IProps extends HTMLProps<HTMLButtonElement | HTMLLinkElement> {
    className?: string;
    children: React.ReactNode;
    renderAs?: string;
    outlined?: boolean;
    inverted?: boolean;
    uppered?: boolean;
    isSize?: SIZE;
    state?: STATE;
    submit?: boolean;
    reset?: boolean;
    fullwidth?: boolean;
    loading?: boolean;
    disabled?: boolean;
    remove?: boolean;
    isSelected?: boolean;
    isStatic?: boolean;
    onClick?: (evt: any) => any;
    text?: boolean;
    domRef?: any;
}

function Button(props: IProps) {
    const {
        children,
        className,
        renderAs = 'button',
        color,
        size,
        isSize,
        outlined,
        inverted,
        uppered,
        state,
        submit,
        reset,
        fullwidth,
        loading,
        disabled,
        remove,
        isSelected,
        isStatic,
        onClick,
        text,
        domRef,
        ...rest
    } = props;
    let otherProps = {};
    if (submit) {
        otherProps = {
            type: 'submit',
            renderAs: renderAs || 'button',
        };
    }
    if (reset) {
        otherProps = {
            type: 'reset',
            renderAs: renderAs || 'button',
        };
    }

    if (isStatic) {
        otherProps = {
            renderAs: 'span',
        };
    }
    return (
        <Element
            tabIndex={disabled ? -1 : 0}
            renderAs={renderAs}
            domRef={domRef}
            {...rest}
            {...otherProps}
            disabled={disabled}
            onClick={disabled ? undefined : onClick}
            className={classnames(styles['bm-btn'], className, {
                [styles[`is-${color}`]]: color,
                [styles[`is-${size}`]]: size,
                [styles[`is-${isSize}`]]: isSize,
                [styles[`is-${state}`]]: state,
                [styles['is-outlined']]: outlined,
                [styles['is-selected']]: isSelected,
                [styles['is-static']]: isStatic,
                [styles['is-inverted']]: inverted,
                [styles['is-fullwidth']]: fullwidth,
                [styles['is-loading']]: loading,
                [styles['is-text']]: text,
                [styles['is-upper']]: uppered,
                [styles.delete]: remove,
                [styles.button]: !remove,
            })}
        >
            {children}
        </Element>
    );
}

export default memo(Button);
